module.exports = __webpack_public_path__ + "static/media/editing-page.22da55be.png";